// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__2r7fD","fillColor":"IconSuccess_fillColor__BKiQ6"};